import React from "react";
import { Navigate } from "react-router-dom";
import { routes } from "../constants/routes";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Check if the user is authenticated
  const authToken = localStorage.getItem("authToken");

  // Redirect to login if not authenticated
  if (!authToken) {
    return <Navigate to={routes.LOGIN} replace />;
  }

  return children;
};

export default ProtectedRoute;
